import {
  SubContainer,
  ServicesGrid,
  FormField,
  Button,
  SubTitle
} from '../styles'

export default function CategoriesForm ({
  services = [],
  serviceCategories = [],
  onProceed: handleProceed = () => null
}) {
  const businessServiceCategories = serviceCategories.filter (category => (
    services.some (service => service.category.id === category.id)
  ))

  if (businessServiceCategories.length === 0) {
    return (
      <SubContainer>
        <FormField>
          <SubTitle>
            Este salão ainda não possui serviços habilitados para agendamento online.
          </SubTitle>
        </FormField>
      </SubContainer>
    )
  }

  return (
    <SubContainer>
      <SubTitle>Escolha a categoria de serviço</SubTitle>
      <ServicesGrid>
        {businessServiceCategories.map ((category, index) => (
          <Button
            key={index}
            onClick={() => handleProceed ({ service_category:category })}
          >
            {category.name}
          </Button>
        ))}
      </ServicesGrid>
    </SubContainer>
  )
}
